import styled from 'styled-components';
import { Grid } from '../../atoms';
export const GridContainer = styled(Grid)`
  overflow-x: auto;
  padding: 16px 0;
`;
export const GridCard = styled(Grid)`
  gap: 12px;
  display: flex;
  flex-wrap: nowrap;
`;